import React from 'react';
import ProductSidebarComponent from './ProductSidebarComponent';
import { PageHeader } from '../../components';

const ManpowerSupply: React.FC = () => {
  return (
    <>
      <PageHeader title="Manpower Supply for Water & Wastewater Plants" breadcrumbs={[{ label: "Products", path: "/products" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-3.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-1.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Manpower Supply for Water & Wastewater Plants</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>Reliable and trained manpower is the backbone of efficient water and wastewater plant operations. At Wasser Technochem (I) Ltd., we provide skilled, semi-skilled, and highly trained technical manpower for WTPs, STPs, ETPs, RO plants, DM plants, and utility systems across industries and municipal bodies. Our personnel are trained in SOP-based operations, safety protocols, chemical handling, and automated systems.</p>
              <p>Whether it's a greenfield plant or a brownfield retrofit, our manpower services ensure smooth day-to-day operations, regulatory compliance, and 24x7 plant availability with minimal supervision.</p>

              <h3 className="mb-4">Scope of Services</h3>
              <div className="row g-4 mb-4">
                <div className="col-md-6">
                  <p><i className="fa fa-user-cog text-primary me-2"></i>Operators (RO, DM, ETP/STP, ZLD, WTP)</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-tools text-primary me-2"></i>Fitters, helpers, and electrical technicians</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-microchip text-primary me-2"></i>Instrumentation and SCADA professionals</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-flask text-primary me-2"></i>Plant chemists and shift in-charge</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-user-tie text-primary me-2"></i>Supervisors and maintenance coordinators</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-shield-alt text-primary me-2"></i>Safety and EHS-trained utility workers</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-phone-alt text-primary me-2"></i>On-call manpower for emergency/temporary operations</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-map-marker-alt text-primary me-2"></i>Deputation for AMC/O&M contracts and remote sites</p>
                </div>
              </div>

              <h3 className="mb-4">Deployment Models</h3>
              <div className="row g-4 mb-4">
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-calendar text-primary me-2"></i>Contract-Based</h5>
                      <p>Monthly contract-based placement</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-handshake text-primary me-2"></i>Turnkey Agreements</h5>
                      <p>Manpower under O&M turnkey agreements</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-clock text-primary me-2"></i>Flexible Shifts</h5>
                      <p>Shift-based deployment (8hr/12hr/24x7)</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-shipping-fast text-primary me-2"></i>Rapid Deployment</h5>
                      <p>Mobilization within 15-30 days across India</p>
                    </div>
                  </div>
                </div>
              </div>

              <h3 className="mb-4">Benefits</h3>
              <div className="row g-4 mb-5">
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Skilled Workforce</h5>
                  <p>Skilled and pre-trained workforce specific to water treatment</p>
                </div>
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Reduced Training</h5>
                  <p>Reduces training burden on clients</p>
                </div>
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Minimized Downtime</h5>
                  <p>Minimizes downtime and human error</p>
                </div>
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Rapid Deployment</h5>
                  <p>Rapid deployment for new or emergency plant needs</p>
                </div>
                <div className="col-md-12">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Full Compliance</h5>
                  <p>Full compliance with PF, ESI, and labor regulations</p>
                </div>
              </div>

              <h3 className="mb-4">Why WTIL?</h3>
              <div className="row g-4">
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-users text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Large Scale Deployment</h5>
                      <p className="mb-0">Over 350+ operators deployed across industries & large STPs/WTPs/CETPs</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-graduation-cap text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Training Programs</h5>
                      <p className="mb-0">In-house training programs and refresher sessions</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-city text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Diverse Client Base</h5>
                      <p className="mb-0">Experience with ULBs, Smart Cities, and large industrial clients</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-expand-arrows-alt text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Scalable Solutions</h5>
                      <p className="mb-0">Flexibility in workforce scale-up for large-capacity plants</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-umbrella text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>One-Stop Solution</h5>
                      <p className="mb-0">Single-point manpower & chemical supply under one umbrella</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <ProductSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default ManpowerSupply;
